import React, { useRef, useEffect, useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'

import I18n from '@galo-monitor/i18n'
import { AuthenticationActions } from '@galo-monitor/stores/authentication'
import ForgotPasswordForm from '@galo-monitor/web-containers/forms/auth/ForgotPasswordForm'
import { Item, ForgotButton } from '@galo-monitor/web-containers/layouts/GuestLayout/theme'
import { useRoutes } from '@galo-monitor/web-containers/routes/guest'

const ForgotPasswordScreen = () => {
  const formRef = useRef(null)

  const dispatch = useCallback(useDispatch())
  const { routes } = useRoutes()

  useEffect(
    () => {
      dispatch(AuthenticationActions.resetAuthentication())
    },
    [dispatch]
  )

  return (
    <Item>
      <ForgotPasswordForm ref={ formRef } />

      <ForgotButton>
        <Link to={ routes.login.path }>
          <I18n>go back to login screen</I18n>
        </Link>
      </ForgotButton>
    </Item>
  )
}

export default ForgotPasswordScreen
